import "./ModalConfiguraciones.css";

import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { CambiarClaveContext } from "../../context/CambiarClaveContext";

const ModalConfiguraciones = (props) => {
  const { show, onHide, tipoCuenta, usuario } = props;
  const { onSubmit } = useContext(CambiarClaveContext);
  const { control, handleSubmit, formState, reset } = useForm();
  const { errors } = formState;

  // visibilidad de cada campo de contraseña (mostrar/ocultar)
  const [verClaves, setVerClaves] = useState({
    anterior: false,
    nueva: false,
    confirmar: false,
  });

  const alternarClave = (campo) =>
    setVerClaves((actual) => ({ ...actual, [campo]: !actual[campo] }));

  // al cerrar el modal se limpian los campos de contraseña y su visibilidad
  const limpiarFormulario = () => {
    reset({ anterior: "", nueva: "", confirmar: "" });
    setVerClaves({ anterior: false, nueva: false, confirmar: false });
  };

  // La seccion "Perfil" se muestra cuando la sidebar envia los datos de cuenta.
  const mostrarDatosCuenta = tipoCuenta !== undefined || usuario !== undefined;

  const campoClave = (name, label) => (
    <div className="modal-perfil-aliado-campo">
      <label className="modal-perfil-aliado-label" htmlFor={`perfil-${name}`}>
        {label}
      </label>
      <div className="modal-perfil-aliado-input-wrap">
        <Controller
          name={name}
          control={control}
          rules={{ required: "Campo requerido" }}
          render={({ field }) => (
            <input
              id={`perfil-${name}`}
              className="modal-perfil-aliado-input"
              type={verClaves[name] ? "text" : "password"}
              {...field}
            />
          )}
        />
        <button
          type="button"
          className="modal-perfil-aliado-ojo"
          onClick={() => alternarClave(name)}
          aria-label={verClaves[name] ? "Ocultar contraseña" : "Mostrar contraseña"}
        >
          <FontAwesomeIcon icon={verClaves[name] ? faEyeSlash : faEye} />
        </button>
      </div>
      {errors[name] && (
        <p className="modal-perfil-aliado-error">{errors[name].message}</p>
      )}
    </div>
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      onExited={limpiarFormulario}
      centered
      dialogClassName="modal-perfil-aliado-dialog"
      contentClassName="modal-perfil-aliado-content"
      aria-labelledby="modal-perfil-aliado-titulo"
    >
      <Modal.Body className="modal-perfil-aliado-body">
        <button
          type="button"
          className="modal-perfil-aliado-cerrar"
          onClick={onHide}
          aria-label="Cerrar"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>

        <form onSubmit={handleSubmit(onSubmit)}>
          {mostrarDatosCuenta && (
            <>
              <h5 className="modal-perfil-aliado-titulo" id="modal-perfil-aliado-titulo">
                Perfil
              </h5>

              <div className="modal-perfil-aliado-campo">
                <span className="modal-perfil-aliado-label">Tipo de cuenta</span>
                <input
                  className="modal-perfil-aliado-input is-readonly"
                  type="text"
                  value={tipoCuenta || ""}
                  readOnly
                  tabIndex={-1}
                />
              </div>

              <div className="modal-perfil-aliado-campo">
                <span className="modal-perfil-aliado-label">CUIT / Usuario</span>
                <input
                  className="modal-perfil-aliado-input is-readonly"
                  type="text"
                  value={usuario || ""}
                  readOnly
                  tabIndex={-1}
                />
              </div>
            </>
          )}

          <h5
            className={`modal-perfil-aliado-titulo${
              mostrarDatosCuenta ? " modal-perfil-aliado-titulo-secundario" : ""
            }`}
          >
            Cambiar contraseña
          </h5>

          {campoClave("anterior", "Contraseña anterior")}
          {campoClave("nueva", "Nueva contraseña")}
          {campoClave("confirmar", "Repita nueva contraseña")}

          <div className="modal-perfil-aliado-acciones">
            <button
              className="modal-perfil-aliado-guardar lato-bold"
              type="submit"
            >
              Guardar cambios
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalConfiguraciones;
